// auth.js
// Utilidades para guardar y recuperar el token JWT

export function saveToken(token) {
  if (typeof window !== 'undefined') {
    localStorage.setItem('jwt_token', token)
  }
}

export function getToken() {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('jwt_token')
  }
  return null
}

export function clearToken() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('jwt_token')
  }
}
